import {createGlobalStore} from "../../ui/store.js"
// import {randomId} from "../../ui/utils";

createGlobalStore(function (state = {
    count: 0,
    items: [
        {key:0, text:"Implement full featured client side routing"},
        {key:1, text:"Implement a REAL store (not redux) "},
        {key:2, text:"Create a working app template"},
        {key:3, text:"Make some showcases"}
        ]
}, action) {
    switch (action.name) {
        case 'inc':
            return {
                ...state,
                count: state.count + 1
            };
        case 'dec':
            return {
                ...state,
                count: state.count - 1
            };
        case 'additem': {
            return {
                ...state,
                items: [...state.items, action.payload]
            }
        }
        case 'removeitem': {
            let items = state.items.reverse();
            // let idx = state.items.findIndex((it)=>it.key === action.payload.key );
            // if (idx>=0) items.splice(idx, 1);
            return {
                ...state,
                items: items
            }
        }
        default:
            return state
    }
})